<template>
  <div
    class="absolute left-1/2 top-5 z-50 hidden max-w-32 -translate-x-1/2 overflow-hidden whitespace-nowrap bg-primary px-2 py-1 text-xs text-white opacity-0 transition-all after:absolute after:bottom-0 after:left-1/2 after:size-0 after:-translate-x-1/2 after:translate-y-full after:border-x-[5px] after:border-b-[0] after:border-t-[5px] after:border-solid after:border-x-transparent after:border-b-transparent after:border-t-primary after:content-[''] group-hover:-translate-y-1/2 group-hover:opacity-100 lg:flex lg:max-w-40"
  >
    <div class="overflow-hidden text-ellipsis">
      <slot></slot>
    </div>
  </div>
</template>
